var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRedPeopleIcon = function SvgRedPeopleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#red-people-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF2458",
    d: "M5.669 9.703a3.164 3.164 0 1 1 0-6.328 3.164 3.164 0 0 1 0 6.328Zm0-4.922a1.758 1.758 0 1 0 0 3.516 1.758 1.758 0 0 0 0-3.516Zm5.273 11.953v-.351a5.274 5.274 0 0 0-10.546 0v.351a.703.703 0 0 0 1.406 0v-.351a3.867 3.867 0 1 1 7.734 0v.351a.703.703 0 0 0 1.406 0Zm6.328-3.515A4.922 4.922 0 0 0 9.067 9.55a.703.703 0 1 0 .938 1.047 3.516 3.516 0 0 1 5.86 2.62.703.703 0 1 0 1.405 0ZM12.7 6.89a3.164 3.164 0 1 1 0-6.33 3.164 3.164 0 0 1 0 6.33Zm0-4.922a1.758 1.758 0 1 0 0 3.515 1.758 1.758 0 0 0 0-3.515Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "red-people-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.396.563H17.27v16.875H.396z"
  })))));
};
export default SvgRedPeopleIcon;